/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Material ExpandMore Icon component.
 */
const Icon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='MapPinIcon' {...props} legacyIcon={(
      <svg xmlns='http://www.w3.org/2000/svg' height={iconSize} viewBox='0 0 24 24' width={iconSize} fill='none'>
        <path d='M11.9749 20.8844L12.4531 21.2802L12.9314 20.8844C14.4118 19.659 15.9657 17.5665 17.1439 15.451C17.7372 14.3856 18.2471 13.2935 18.6104 12.2747C18.9698 11.2669 19.2031 10.2832 19.2031 9.4495C19.2031 6.29453 16.7218 2.55664 12.4531 2.55664C8.18448 2.55664 5.70312 6.29453 5.70312 9.4495C5.70312 10.2832 5.93649 11.2669 6.29587 12.2747C6.6592 13.2935 7.16903 14.3856 7.76236 15.451C8.94057 17.5665 10.4945 19.659 11.9749 20.8844Z' stroke={iconColor} strokeWidth='1.5' />
        <circle cx='12.4531' cy='9.80664' r='2.25' stroke={iconColor} strokeWidth='1.5' />
      </svg>
    )} />
  );
};

export const MapPinIcon = memo(Icon);
